import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";
import Checkbox from "@material-ui/core/Checkbox";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "./MyButton";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const danhmuc = require("../lib/DanhMucLayer");
const uuidV4 = require("uuid/v4");

class ParallelSearchEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCalculate = this.handleCalculate.bind(this);
    var feature = {};
    if (props.value !== undefined) {
      //thong tin feature de edit
      var feature = props.value;
      var coord = feature.getGeometry().getCoordinates();
      var saved = feature.get("saved");
      if (true === saved) {
        //feature da co trong csdl
        var data = feature.get("data");
        feature = {
          ID: data.ID,
          Ten: data.Ten,
          Loai: "ParallelSearch",
          ToaDo: data.JsonData.ToaDo,
          Square_Course: data.JsonData.Square_Course,
          Square_Leg: data.JsonData.Square_Leg,
          Square_Spacing: data.JsonData.Square_Spacing,
          Square_Number: data.JsonData.Square_Number,
          Square_Speed: data.JsonData.Square_Speed,
          Square_First: data.JsonData.Square_First,
          Search_Distance: data.JsonData.Search_Distance,
          Search_Time: data.JsonData.Search_Time,
        };
      } else {
        var toado = "";
        coord.map(
          (item, index) =>
            (toado +=
              (toado !== "" ? "\n" : "") +
              myLib.latToDMS(item[1]) +
              "-" +
              myLib.lonToDMS(item[0]))
        );
        feature = {
          ID: uuidV4() + "",
          Ten: "",
          Loai: "ParallelSearch",
          ToaDo: toado,
          //square search
          Square_Course: 0,
          Square_Leg: 4,
          Square_Spacing: 1,
          Square_Number: 4,
          Square_Speed: 15,
          Square_First: true,
          Search_Distance: 0,
          Search_Time: 0,
        };
      }
    }
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "md",
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_tausar: true, // co dang load ding danh muc nguon tin ko
      source_tausar: [], //danh muc options cho nguon tin
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              Ten: "",
              ToaDo: "",
            }
          : feature, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, ["Ten", "ToaDo"]);
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = (action) => {
    if (action !== "xoa") {
      var check = { error: false };
      console.log("check", check);
      if (!check.error) {
        //console.log(JSON.stringify(this.state.after));
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("hinhve/save", this.state.after)
          .then((response) => {
            var before = {};
            var after = { ...this.state.after };
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
              saved: true,
            });
            //thay doi toa do feature
            var feature = this.props.value;
            console.log(response.JsonData);
            response.JsonData = JSON.parse(response.JsonData);
            feature.set("data", response);
            feature.set("type", "ParallelSearch");
            feature.set("saved", true);
            var coord = response.Coordinates;
            feature.getGeometry().setCoordinates(coord);
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(feature, action);
            }
            this.handleClose(true);
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
      } else {
        this.setState({ validateStatus: check });
      }
    } else {
      //thuc hien xoa
      var feature = this.props.value;
      if (feature.get("saved") === true) {
        this.setState({ saving: true, errorLog: "" });
        server
          .post("hinhve/xoa", this.state.after)
          .then((response) => {
            var before = {};
            this.setState({
              saving: false,
              errorLog: "",
            });
            if (this.props.onSaved) {
              this.props.onSaved(feature, action);
            }
            this.handleClose(action);
          })
          .catch((error) => {
            console.log(error);
            this.setState({ saving: false, errorLog: error + "" });
          });
      } else {
        if (this.props.onSaved) {
          this.props.onSaved(feature, action);
        }
        this.handleClose(action);
      }
    }
  };
  componentDidMount() {
    this.loadDanhMuc();
    this.loadEdit();
  }
  loadDanhMuc() {
    //load danh muc doi tac
    /*
    server
      .query("tausar/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.TenTau, label: item.TenTau })
        );
        this.setState({ source_tausar: list, loading_tausar: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_tausar: false });
      });*/
  }
  loadEdit() {
    //kiem tra xem co phai che do edit hay khong
    var mask = this.props.MaTN;
    if (mask !== undefined) {
      //load va hien thi thong tin su kien
      server
        .query("tainan/get?maso=" + mask)
        .then((response) => {
          //thong tin su kien
          var sukien = response;
          sukien = danhmuc.chuyenDoi("tainan", sukien); //chuyen doi gia tri
          console.log(sukien, "chuyen doi");
          this.setState({
            formReady: true,
            before: sukien,
            after: myLib.cloneObject(sukien),
          });
          console.log("ket qua truy van", sukien);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_tainan: false, errorLog: error + "" });
        });
    } else {
      this.setState({ formReady: true });
    }
  }
  handleClose = (result) => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose(result);
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  //thuc hien tinh toan toa do va cac gia tri
  handleCalculate = () => {
    console.log(this.state);
    try {
      var toado_moi = "";
      var sodiem = this.state.after.Square_Number * 4; //so diem phai tinh
      var first = this.state.after.ToaDo.split(/\r?\n/)[0].split("-");
      var approach = this.state.after.Square_Course;
      var leg_distancex = this.state.after.Square_Leg;
      var leg_distancey = this.state.after.Square_Spacing;
      var leg_distancez = leg_distancey;
      var SAR_distance = 0;
      var first_ship = !this.state.after.Square_First;
      if (first.length > 1) {
        var lat = myLib.latFromDMS(first[0]); //xac dinh toa do diem xuat phat
        var lon = myLib.lonFromDMS(first[1]);
        toado_moi = myLib.latToDMS(lat) + "-" + myLib.lonToDMS(lon);
        var n = 0;
        //int multiplier=1;
        var ESheading = approach + 180.0,
          ESdistance = leg_distancex / 2;
        //calculate start position
        var pos = myLib.calculateRhumbLine([lon, lat], -ESheading, ESdistance);
        lat = pos[1];
        lon = pos[0];
        //toado_moi += "\n" + myLib.latToDMS(lat) + "-" + myLib.lonToDMS(lon);
        ESheading = !first_ship ? approach + 90.0 : approach - 90.0;
        pos = myLib.calculateRhumbLine(
          [lon, lat],
          -ESheading,
          leg_distancez / 2
        );
        lat = pos[1];
        lon = pos[0];
        toado_moi += "\n" + myLib.latToDMS(lat) + "-" + myLib.lonToDMS(lon);
        var nlegs = this.state.after.Square_Number;
        for (var x = 1; x <= nlegs; x++) {
          //Loop over the number of legs
          for (var y = 0; y <= 1; y++) {
            //Loop over the tracks
            if (y == 0) {
              if (x % 2 != 0) {
                ESheading = approach;
              } else {
                ESheading = approach + 180.0;
              }
              ESdistance = leg_distancex;
            } else {
              ESdistance = leg_distancey;
              if (!first_ship) ESheading = approach + 90.0;
              else ESheading = approach - 90.0;
            }

            n++;

            var pos = myLib.calculateRhumbLine(
              [lon, lat],
              -ESheading,
              ESdistance
            );
            SAR_distance += ESdistance;
            lat = pos[1];
            lon = pos[0];
            toado_moi += "\n" + myLib.latToDMS(lat) + "-" + myLib.lonToDMS(lon);
          }
        }
        var time =
          Math.round(
            (Math.round(SAR_distance * 100) /
              100 /
              this.state.after.Square_Speed) *
              100
          ) / 100;
        this.setState({
          after: {
            ...this.state.after,
            ToaDo: toado_moi,
            Search_Distance: Math.round(SAR_distance * 100) / 100,
            Search_Time: time,
          },
          dataChanged: true,
          canSaved: true,
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Square Search
                </Typography>
                <Button color="inherit" onClick={() => this.handleSave("xoa")}>
                  Xóa
                </Button>
                <Button
                  color="inherit"
                  onClick={() => this.handleClose(this.state.saved === true)}
                >
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              <div style={{ height: 450 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      id="txtTen"
                      className={classes.textbox}
                      label="Tên đường:"
                      value={this.state.after.Ten}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Ten", event.target.value)
                      }
                      error={this.state.validateStatus.Ten !== undefined}
                      helperText={
                        this.state.validateStatus.Ten !== undefined
                          ? this.state.validateStatus.Ten.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="txtHuong"
                      type="number"
                      className={classes.textbox}
                      label="Hướng tiếp cận(độ):"
                      value={this.state.after.Square_Course}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Square_Course", event.target.value)
                      }
                      error={
                        this.state.validateStatus.Square_Course !== undefined
                      }
                      helperText={
                        this.state.validateStatus.Square_Course !== undefined
                          ? this.state.validateStatus.Square_Course.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="Square_Leg"
                      className={classes.textbox}
                      type="number"
                      label="Độ dài bước(NM):"
                      value={this.state.after.Square_Leg}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Square_Leg", event.target.value)
                      }
                      error={this.state.validateStatus.Square_Leg !== undefined}
                      helperText={
                        this.state.validateStatus.Square_Leg !== undefined
                          ? this.state.validateStatus.Square_Leg.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="Square_Spacing"
                      className={classes.textbox}
                      type="number"
                      label="Khoảng cách bước(NM):"
                      value={this.state.after.Square_Spacing}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Square_Spacing", event.target.value)
                      }
                      error={
                        this.state.validateStatus.Square_Spacing !== undefined
                      }
                      helperText={
                        this.state.validateStatus.Square_Spacing !== undefined
                          ? this.state.validateStatus.Square_Spacing.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="Square_Number"
                      className={classes.textbox}
                      type="number"
                      label="Số lượt:"
                      value={this.state.after.Square_Number}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Square_Number", event.target.value)
                      }
                      error={
                        this.state.validateStatus.Square_Number !== undefined
                      }
                      helperText={
                        this.state.validateStatus.Square_Number !== undefined
                          ? this.state.validateStatus.Square_Number.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="Square_Speed"
                      className={classes.textbox}
                      type="number"
                      label="Tốc độ:"
                      value={this.state.after.Square_Speed}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Square_Speed", event.target.value)
                      }
                      error={
                        this.state.validateStatus.Square_Speed !== undefined
                      }
                      helperText={
                        this.state.validateStatus.Square_Speed !== undefined
                          ? this.state.validateStatus.Square_Speed.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.after.Square_First}
                          onChange={(event) =>
                            this.saveField("Square_First", event.target.checked)
                          }
                          name="chkTimKiem"
                        />
                      }
                      label="First ship"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="Search_Distance"
                      className={classes.textbox}
                      type="number"
                      label="Quãng đường:"
                      value={this.state.after.Search_Distance}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Search_Distance", event.target.value)
                      }
                      error={
                        this.state.validateStatus.Search_Distance !== undefined
                      }
                      helperText={
                        this.state.validateStatus.Search_Distance !== undefined
                          ? this.state.validateStatus.Search_Distance.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="Search_Time"
                      className={classes.textbox}
                      type="number"
                      label="Thời gian:"
                      value={this.state.after.Search_Time}
                      inputProps={{
                        maxLength: 150,
                      }}
                      autoFocus={true}
                      onChange={(event) =>
                        this.saveField("Search_Distance", event.target.value)
                      }
                      error={
                        this.state.validateStatus.Search_Time !== undefined
                      }
                      helperText={
                        this.state.validateStatus.Search_Time !== undefined
                          ? this.state.validateStatus.Search_Time.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MyButton
                      onClick={this.handleCalculate}
                      color="primary"
                      text="Tính toán"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="txtToaDo"
                      className={classes.textbox}
                      label="Tọa độ điểm:"
                      value={this.state.after.ToaDo}
                      inputProps={{
                        maxLength: 1050,
                      }}
                      multiline
                      onChange={(event) =>
                        this.saveField("ToaDo", event.target.value)
                      }
                      error={this.state.validateStatus.ToaDo !== undefined}
                      helperText={
                        this.state.validateStatus.ToaDo !== undefined
                          ? this.state.validateStatus.ToaDo.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {this.state.canSaved && this.props.EditMode !== "xoa" ? (
                      <MyButton
                        onClick={this.handleSave}
                        color="primary"
                        text="Lưu"
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={10}>
                    {this.state.saving ? (
                      <CircularProgress />
                    ) : this.state.errorLog === "" ? null : (
                      this.state.errorLog
                    )}
                  </Grid>
                </Grid>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
});
export default withStyles(styles, { withTheme: true })(
  ParallelSearchEditDialog
);
